import { PhaseTypeEnum } from '@vatos-pas/common';

export const getLocationVariantForPhase = (
  phaseType: PhaseTypeEnum | string,
  reqBumpoutTimesheet: boolean | null | undefined,
): 'logged' | 'approved' => {
  if (phaseType === PhaseTypeEnum.Garage) return 'logged';
  const isBump =
    phaseType === PhaseTypeEnum.Bump1 ||
    phaseType === PhaseTypeEnum.Bump2 ||
    phaseType === PhaseTypeEnum.Bump3 ||
    phaseType === PhaseTypeEnum.Bump4 ||
    phaseType === PhaseTypeEnum.Bump5;
  if (isBump && reqBumpoutTimesheet === false) return 'logged';
  return 'approved';
};
